const scrollListener = handler => {
  const rootNode = document.getElementById('scroll-content');
  rootNode.addEventListener('scroll', handler);
};

export default scrollListener;
